import React from 'react';

import { Box, Skeleton, Typography } from '@mui/material';
import PendingChangeWrapper from '@sharedCR/common/PendingChangeWrapper';
import { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';

import { PendingChangesActionType } from 'constants/pendingChanges';

import EntityCard from './components/EntityCard';
import {
  cardsGridStyles,
  identifierItemStyles,
  identifierRowStyles,
  wrapperStyles,
} from './InvestorServicerSummary.styles';
import { entityConfigPropType, fieldPropShape } from './InvestorServicerSummary.types';

const EMPTY_IDENTIFIERS = [];

const InvestorServicerSummary = ({
  isLoading,
  investorConfig,
  servicerConfig,
  identifiersConfig = EMPTY_IDENTIFIERS,
}) => (
  <Box sx={wrapperStyles}>
    <Box sx={cardsGridStyles}>
      <EntityCard
        authors={investorConfig.authors}
        fields={investorConfig.fields}
        icon={investorConfig.icon}
        iconColor={investorConfig.iconColor}
        isLoading={isLoading}
        isModified={investorConfig.isModified}
        name={investorConfig.name}
        title={investorConfig.title}
      />
      <EntityCard
        authors={servicerConfig.authors}
        fields={servicerConfig.fields}
        icon={servicerConfig.icon}
        iconColor={servicerConfig.iconColor}
        isLoading={isLoading}
        isModified={servicerConfig.isModified}
        name={servicerConfig.name}
        title={servicerConfig.title}
      />
    </Box>

    {!!identifiersConfig.length && (
      <Box sx={identifierRowStyles}>
        {identifiersConfig.map(({ id, name, value, isModified, authors }) => (
          <Box key={id} sx={identifierItemStyles}>
            <Typography color="text.secondary" variant="regular14">
              {name}
            </Typography>
            {isLoading ? (
              <Skeleton height={24} variant="text" width="60%" />
            ) : (
              <PendingChangeWrapper
                isSmall
                authors={authors}
                fieldLabel={name}
                pendingChangesActionType={isModified ? PendingChangesActionType.MODIFIED : null}
                textSelector="span"
              >
                <Typography data-truncated className="truncate" variant="medium16">
                  {value}
                </Typography>
              </PendingChangeWrapper>
            )}
          </Box>
        ))}
      </Box>
    )}
  </Box>
);

InvestorServicerSummary.propTypes = {
  ...WithLoadingPropTypes,
  investorConfig: entityConfigPropType,
  servicerConfig: entityConfigPropType,
  identifiersConfig: PropTypes.arrayOf(fieldPropShape),
};

export default InvestorServicerSummary;
